
import { useState } from 'react';
import ScrollAnimation from '../../../components/base/ScrollAnimation';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Michael Johnson',
      rating: 5,
      text: 'Outstanding service! The ceramic tint looks amazing and the heat rejection is incredible. Professional installation and great customer service.',
      vehicle: '2023 Tesla Model 3',
      service: 'Ceramic Tint',
    },
    {
      name: 'Sarah Williams',
      rating: 5,
      text: 'Best mobile tinting service in Baltimore! They came to my office and did a perfect job. Very convenient and the quality is top-notch.',
      vehicle: '2022 BMW X5',
      service: 'Mobile Tinting',
    },
    {
      name: 'David Martinez',
      rating: 5,
      text: 'Highly recommend! The pre-cut kit was easy to install and fits perfectly. Great quality film and excellent customer support throughout.',
      vehicle: '2021 Honda Accord',
      service: 'Pre-Cut Kit',
    },
    {
      name: 'Jennifer Lee',
      rating: 5,
      text: 'Amazing work on my business vehicle decals! Professional design and installation. My company logo looks fantastic and has great visibility.',
      vehicle: '2023 Ford Transit',
      service: 'Vehicle Decals',
    },
    {
      name: 'Robert Brown',
      rating: 5,
      text: 'Exceptional quality and attention to detail. The tint has held up perfectly and still looks brand new after a year. Worth every penny!',
      vehicle: '2022 Mercedes C-Class',
      service: 'Window Tinting',
    },
    {
      name: 'Amanda Garcia',
      rating: 5,
      text: 'Fast, professional, and affordable. The team was courteous and the installation was flawless. My car looks sleek and stays much cooler now.',
      vehicle: '2023 Audi A4',
      service: 'Ceramic Tint',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 max-md:py-8 bg-gradient-to-b from-gray-50 to-white mobile-compact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation animation="fade-in">
          <div className="text-center mb-16 max-md:mb-6 mobile-compact-spacing">
            <h2 className="text-4xl md:text-5xl max-md:text-2xl font-bold text-secondary mb-4 max-md:mb-2">
              What Our Customers Say
            </h2>
            <p className="text-xl max-md:text-sm text-gray-600 max-w-3xl mx-auto mobile-compact-text">
              Don't just take our word for it. See why Baltimore trusts us for premium window tinting services.
            </p>
          </div>
        </ScrollAnimation>

        {/* Featured Testimonial Carousel */}
        <ScrollAnimation animation="slide-up">
          <div className="relative max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl max-md:rounded-lg shadow-2xl p-8 md:p-12 max-md:p-4">
              <div className="flex items-center justify-center mb-6 max-md:mb-3">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent text-2xl max-md:text-lg mx-1 max-md:mx-0.5 w-6 h-6 max-md:w-4 max-md:h-4 flex items-center justify-center"></i>
                ))}
              </div>
              
              <p className="text-xl md:text-2xl max-md:text-sm text-gray-700 text-center mb-8 max-md:mb-4 leading-relaxed mobile-compact-text italic">
                "{testimonials[currentIndex].text}"
              </p>
              
              <div className="text-center">
                <h4 className="text-xl max-md:text-base font-bold text-secondary mb-1">
                  {testimonials[currentIndex].name}
                </h4>
                <p className="text-gray-600 max-md:text-xs mb-1">{testimonials[currentIndex].vehicle}</p>
                <p className="text-primary max-md:text-xs font-semibold">{testimonials[currentIndex].service}</p>
              </div>
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 max-md:-translate-x-2 w-12 h-12 max-md:w-8 max-md:h-8 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line text-2xl max-md:text-lg w-6 h-6 max-md:w-4 max-md:h-4 flex items-center justify-center"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 max-md:translate-x-2 w-12 h-12 max-md:w-8 max-md:h-8 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line text-2xl max-md:text-lg w-6 h-6 max-md:w-4 max-md:h-4 flex items-center justify-center"></i>
            </button>

            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 max-md:mt-3 space-x-2 max-md:space-x-1">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 max-md:w-2 max-md:h-2 rounded-full transition-all cursor-pointer ${
                    index === currentIndex ? 'bg-primary w-8 max-md:w-6' : 'bg-gray-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
